import React from "react";
import Card from "./card";
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
} from "@headlessui/react";

const DisclosureCard = (props) => {
    const { extra, button, content } = props;
    return (
        <Card extra={`${extra}`}>
            <Disclosure defaultOpen={true}>
                <div className="flex flex-col gap-8">
                    <DisclosureButton>{button}</DisclosureButton>

                    <DisclosurePanel>{content}</DisclosurePanel>
                </div>
            </Disclosure>
        </Card>
    );
};

export default DisclosureCard;
